"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableResize_1 = require("./TableResize");
exports.TableResize = TableResize_1.default;
//# sourceMappingURL=index.js.map